import React from 'react';
import {Alert, Button, Col, Divider, Form, InputNumber, Row, Tag, Typography} from "antd";
import {URLS} from "@/lib/urls";
import {SaveOutlined} from "@ant-design/icons";
import toFaNumber, {toFaNumberFormat} from "@/lib/utils/number";
import RenderIf from "@/components/render-if";
const {Title, Text} = Typography;

function ProductDeliverStepCreateCalculateResult({calculationResult, handleBackToCalculate}) {
    return (
        <div>
            <Alert
                message="نتیجه محاسبه"
                description={
                    <div>

                        <Row gutter={16} className="mt-2">
                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2">
                                    <Text type="secondary">تعداد کل ثبت‌نامی‌ها در این سرفصل</Text>
                                    <Title level={4} className="text-green-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.all_registered)}
                                        <div>
                                            نفر
                                        </div>

                                    </Title>
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2">
                                    <Text type="secondary">تعداد پسر</Text>
                                    <Title level={4} className="text-green-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.count_male)}
                                        <div>
                                            نفر
                                        </div>

                                    </Title>
                                </div>
                            </Col>

                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2">
                                    <Text type="secondary">تعداد دختر</Text>
                                    <Title level={4} className="text-green-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.count_female)}
                                        <div>
                                            نفر
                                        </div>

                                    </Title>
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2">
                                    <Text type="secondary">تعداد افراد تکمیل پروفایل نکرده</Text>
                                    <Title level={4} className="text-green-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.unknown_gender)}
                                        <div>
                                            نفر
                                        </div>

                                    </Title>
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2">
                                    <Text type="secondary">تعداد افرادی که قسط عقب مانده ندارند</Text>
                                    <Title level={4} className="text-green-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.without_installment)}
                                        <div>
                                            نفر
                                        </div>

                                    </Title>
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2">
                                    <Text type="secondary">تعداد افرادی که شارژ حساب آنها منفی نیست</Text>
                                    <Title level={4} className="text-green-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.total_count)}
                                        <div>
                                            نفر
                                        </div>

                                    </Title>
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2">
                                    <Text type="secondary">تعداد افراد آماده برای ثبت در این لیست</Text>
                                    <Title level={4} className="text-blue-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.current_count)}
                                        <div>نفر</div>
                                    </Title>
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="p-3  rounded-lg my-2 my-2">
                                    <Text type="secondary">تعداد افرادی که در لیست‌های تحویل قرار گرفته اند</Text>
                                    <Title level={4} className="text-blue-600 mt-1 flex gap-2">
                                        {toFaNumberFormat(calculationResult.delivered)}
                                        <div>نفر</div>
                                    </Title>
                                </div>
                            </Col>
                        </Row>
                        {/* لیست محصولات */}
                        {calculationResult.products && calculationResult.products.length > 0 && (
                            <div className="mt-4">
                                <Divider orientation="">
                                    <Text strong>لیست اقلام
                                        ({toFaNumber(calculationResult.products.length)})</Text>
                                </Divider>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 ">
                                    {calculationResult.products.map((product) => (
                                        <div
                                            key={product.id}
                                            className="p-3   rounded-lg border dark:border-gray-600 border-gray-200 hover:shadow-md transition-shadow"
                                        >
                                            <div className="flex items-start justify-between">
                                                <div className="flex-1">
                                                    <Text strong className="block">{product.title}</Text>
                                                    <div className="flex flex-wrap gap-2 mt-1">
                                                        <Tag
                                                            color="blue">{product.gender === 'male' ? 'مردانه' : product.gender === 'female' ? 'زنانه' : 'عمومی'}</Tag>
                                                        <Tag
                                                            color="green">{product.status === 'published' ? 'منتشر شده' : product.status === 'draft' ? 'پیش‌نویس' : 'بایگانی'}</Tag>
                                                        {product.price && (
                                                            <Tag color="gold">
                                                                {toFaNumberFormat(product.price)} تومان
                                                            </Tag>
                                                        )}
                                                    </div>
                                                    {product.description && (
                                                        <Text type="" className="text-xs block my-2">
                                                            {product.description}
                                                        </Text>
                                                    )}
                                                    <RenderIf
                                                        condition={product?.product_topics?.length > 0}>
                                                        <div className={'text-xs   my-2'}>مربوط
                                                            به سرفصل
                                                        </div>
                                                        <div className="flex flex-wrap gap-1">
                                                            {product.product_topics.map((topic) => (
                                                                <div key={topic?.id}>
                                                                    <Tag
                                                                        color="">{topic?.topic?.title}</Tag>
                                                                </div>
                                                            ))}
                                                        </div>

                                                    </RenderIf>
                                                </div>
                                                {product.file && (
                                                    <div className="ml-2">
                                                        <img
                                                            src={product.file.url}
                                                            alt={product.title}
                                                            className="w-12 h-12 object-cover rounded-lg border dark:border-gray-600 border-gray-200"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                }
                type="info"
                showIcon
                className="mb-6"
                action={
                    <Button
                        size="small"
                        type="link"
                        onClick={handleBackToCalculate}
                    >
                        محاسبه مجدد
                    </Button>
                }
            />
        </div>
    );
}

export default ProductDeliverStepCreateCalculateResult;